import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LocaleSwitch } from '../components/locale-switch/LocaleSwitch';
import { Spinner } from '../components/Spinner';
import { useConvertLegacySession } from '../hooks/useConvertLegacySession';
import { queryClient } from '../services/datastore/react-query';
import { StorageManager } from '../services/storage/StorageManager';
import { ToastManager } from '../services/toast/utils';
import { t } from '../services/translation/translation';
import { clearTokens, TOKENS_STORAGE_KEY } from '../utils/auth';

export const TakeOverRoute = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { mutate: convertLegacySession } = useConvertLegacySession();

  const session = useMemo(() => {
    const s = searchParams.get('s');

    if (!s) return null;

    try {
      return JSON.parse(s);
    } catch (e) {
      console.error(e);
    }

    return s;
  }, [searchParams]);

  useEffect(() => {
    if (session) {
      convertLegacySession(
        {
          id: session.id,
          accessToken: session.accessToken,
          appToken: session.appToken,
          type: session.type,
          userKeyStr: session.userKeyStr,
        },
        {
          onSuccess: data => {
            ToastManager.show({ severity: 'success', message: t('take-over-route.success') });
            StorageManager.setJSONItem(TOKENS_STORAGE_KEY, data);
            navigate('/');
          },
          onError: () => {
            ToastManager.show({ severity: 'error', message: t('take-over-route.error') });
            navigate('/');
          },
        },
      );
    } else {
      clearTokens(queryClient);
      ToastManager.show({ severity: 'error', message: t('take-over-route.invalid-session') });
      navigate('/');
    }
  }, [convertLegacySession, navigate, session]);

  return (
    <div className="h-screen flex items-center justify-center relative">
      <Spinner />
      <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
        <LocaleSwitch />
      </div>
    </div>
  );
};
